import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { useContext, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { GetPersonInvestmentProgrammesRes } from '@dealstack/shared/lib/generated';
import { getPersonInvestmentProgrammesRequest } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/apis/useInvestmentProgrammes.ts';

export const usePersonInvestmentProgrammes = () => {
	const { selectedEntityId } = useContext(CapManageControllerContext);
	const [linkInvestmentProgrammeToPerson, setLinkInvestmentProgrammeToPerson] =
		useState<boolean>(false);
	const [unlinkInvestmentProgramme, setUnlinkInvestmentProgramme] =
		useState<GetPersonInvestmentProgrammesRes | null>(null);

	const {
		data: investmentProgrammes,
		isFetching: investmentProgrammesFetching,
		refetch: refetchInvestmentProgrammes,
	} = useQuery({
		queryKey: ['investmentProgrammes', selectedEntityId],
		queryFn: () => getPersonInvestmentProgrammesRequest(selectedEntityId),
		enabled: !!selectedEntityId,
	});

	return {
		investmentProgrammes: investmentProgrammes ?? [],
		investmentProgrammesFetching,
		refetchInvestmentProgrammes,
		linkInvestmentProgrammeToPerson,
		setLinkInvestmentProgrammeToPerson,
		unlinkInvestmentProgramme,
		setUnlinkInvestmentProgramme,
	};
};
